<template>
  <div class="play-container">
    <div class="section-part">
      <Cases />
      <Special />
      <Skin />
    </div>
  </div>
</template>

<script>
import Cases from "./cases";
import Special from "./special";
import Skin from "./skin";
export default {
  components: { Cases, Special, Skin },
  props: {},
  data() {
    return {}
  },
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>